import { render } from "./ProductChart.vue?vue&type=template&id=5fb7d20e"
import script from "./ProductChart.vue?vue&type=script&lang=js"
export * from "./ProductChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\ArbeitFinderundBeraterVersionen\\MonitorBerater\\MonitorweltBerater\\FindingoBerater\\BeforeWordpressBerater_new_WordpressProduction\\newDataForm\\newDataForm\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__